import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/app/ui/assets/svg/icon-dot.svg'
import _imports_1 from '@/app/ui/assets/svg/ics_o_chevron_right-red.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-6bb2b80c")

_pushScopeId("data-v-6bb2b80c")
const _hoisted_1 = { class: " text-base font-semibold leading-tight" }
const _hoisted_2 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_3 = { class: "flex flex-row gap-1 items-center" }
const _hoisted_4 = { class: "text-black-lp-100" }
const _hoisted_5 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: " w-1 h-1 ",
  alt: "icon-dot"
}, null, -1)
const _hoisted_6 = { class: "text-black-lp-100" }
const _hoisted_7 = { class: "flex items-start gap-4" }
const _hoisted_8 = /*#__PURE__*/_createVNode("span", null, [
  /*#__PURE__*/_createVNode("img", {
    src: _imports_1,
    class: " w-5 h-5 ",
    alt: "icon-dot"
  })
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_DatePicker = _resolveComponent("DatePicker")!
  const _component_Tabs = _resolveComponent("Tabs")!
  const _component_DetailLayout = _resolveComponent("DetailLayout")!
  const _component_PopupHarusDisetor = _resolveComponent("PopupHarusDisetor")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_DetailLayout, {
      onBack: _ctx.goBack,
      "vertical-separator": false,
      fullPage: "",
      "is-floating-action": false,
      headerNewLayout: true,
      usePaddingVertical: "py-0",
      customClass: "overflow-y-auto"
    }, {
      title: _withId(() => [
        _createVNode("div", _hoisted_1, [
          _createTextVNode(_toDisplayString(_ctx.$t("codReconcile.dailyDeposit.titleSetorHarian")), 1),
          _hoisted_2,
          _createVNode("div", _hoisted_3, [
            _createVNode("span", _hoisted_4, _toDisplayString(_ctx.localDetailDataCourier?.courierName ||
            _ctx.$t("codReconcile.dailyDeposit.courierUnknown")), 1),
            _hoisted_5,
            _createVNode("span", _hoisted_6, _toDisplayString(_ctx.localDetailDataCourier?.courierId || "0"), 1)
          ])
        ])
      ]),
      "top-right": _withId(() => [
        _createVNode("div", _hoisted_7, [
          _createVNode("button", {
            class: "btn-check px-4 py-2 flex flex-row gap-1 items-center justify-center",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.openAmountDueDailyDeposit && _ctx.openAmountDueDailyDeposit(...args)))
          }, [
            _createVNode("span", null, _toDisplayString(_ctx.$t("codReconcile.detail.checkRemainingDeposit")), 1),
            _hoisted_8
          ]),
          _createVNode(_component_DatePicker, {
            onSelected: _ctx.onSelectDatePicker,
            modelValue: _ctx.filterDate,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.filterDate = $event)),
            "max-date": new Date(),
            class: " w-full mr-2",
            disabled: ""
          }, null, 8, ["onSelected", "modelValue", "max-date"])
        ])
      ]),
      data: _withId(() => [
        (_ctx.localDetailDataCourier?.courierId)
          ? (_openBlock(), _createBlock(_component_Tabs, {
              key: 0,
              modelValue: _ctx.activeTab,
              onChange: _ctx.onChangeTabs,
              data: _ctx.tabs,
              rounded: false,
              titleSize: 16,
              gap: 10,
              marginTop: 0,
              marginBottom: 0,
              newHeaderLayout: true
            }, {
              default: _withId(() => [
                (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.currentTabComponent), {
                  key: _ctx.filterDateString,
                  ref: `refs-${_ctx.activeTab === 'uang' ? 'uang' : 'paket'}`,
                  courier: _ctx.localDetailDataCourier,
                  detailCourierPendingApproval: _ctx.detailCourierPendingApproval,
                  "filter-date": _ctx.filterDateString,
                  onRefresh: _ctx.getDetailCourier
                }, null, 8, ["courier", "detailCourierPendingApproval", "filter-date", "onRefresh"]))
              ]),
              _: 1
            }, 8, ["modelValue", "onChange", "data"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["onBack"]),
    (_ctx.openPopupAmountDue)
      ? (_openBlock(), _createBlock(_component_PopupHarusDisetor, {
          key: 0,
          modelValue: _ctx.openPopupAmountDue,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.openPopupAmountDue = $event)),
          detailDataCourier: _ctx.detailDataCourier,
          filterDate: _ctx.filterDateString,
          onDeposit: _ctx.refreshDailyDeposit,
          onClose: _ctx.closeAmountDue
        }, null, 8, ["modelValue", "detailDataCourier", "filterDate", "onDeposit", "onClose"]))
      : _createCommentVNode("", true)
  ], 64))
})